// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_40G","cls2":"RelatedWorksCard-cls2_pSW RelatedWorksCard-cls1_40G"};